import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { curationsApiPath } from './apiPath';

export const PostProductLikeRequestSchema = z.object({
  goodsNo: z.number(),
  action: z.enum(['LIKE', 'UNLIKE']),
});

export type PostProductLikeRequest = z.infer<typeof PostProductLikeRequestSchema>;

export const PostProductLikeResponseDataSchema = z.object({
  success: z.boolean(),
  data: z.object({
    goodsNo: z.number(),
    isLiked: z.boolean(),
  }),
});

export type PostProductLikeResponseData = z.infer<typeof PostProductLikeResponseDataSchema>;

export type PostProductLikeResponse = MusinsaStandardResponse<PostProductLikeResponseData>;

export const postProductLike = (params: PostProductLikeRequest) =>
  executeStandardRequest(() =>
    privateHttpClient.post<PostProductLikeResponse>(
      urlJoin(curationsApiPath.postProductLike),
      params,
    ),
  );
